import type { ReactNode } from "react"
import { View, type ViewStyle } from "react-native"
import { useIsDesktop } from "@/hooks/useIsDesktop"

export const BFColumn = ({
  children,
  noBorder = false,
  className = "",
  style = {},
}: {
  children: ReactNode
  noBorder?: boolean
  className?: string
  style?: ViewStyle
}) => {
  const isDesktop = useIsDesktop()
  return (
    <View
      style={style}
      className={`flex-1 max-w-[700px] ${isDesktop && !noBorder ? "border-gray-300 border-x" : ""} ${className}`}
    >
      {children}
    </View>
  )
}
